import { SubmitButton } from 'components/common/buttons/SubmitButton';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { selectCustomStyles } from '../common/Select';
import { AsyncPaginate } from 'react-select-async-paginate';
import ErrorMessage from 'components/common/ErrorMessage';
import { fetchVendorInterpreters } from 'slices/vendor/interpreterSlice';
import { fetchAvailableVendorInterpreters } from 'slices/vendor/interpreterSlice';

function SelectInterpreterModal({
    isOpen,
    onClose,
    onConfirm,
    item,
    loader,
    appointmentId,
    modalType = 'assign',
}) {


    const dispatch = useDispatch();
    const methods = useForm();
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors } = methods



    useEffect(() => {
        methods.reset({})
    }, [isOpen])


    useEffect(() => {
        setValue("interpreter_id", item?.appointment_assign?.interpreter_id || "");
    }, [item, isOpen])


    // #region Interpreter Dropdown 
    const [filterInterpreters, setFilterInterpreters] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        if (item?.interpreter?.first_name && item?.interpreter?.id) {
            setFilterInterpreters({
                label: `${item?.interpreter?.first_name || ""} ${item?.interpreter?.last_name || ""}`.trim(),
                value: item?.interpreter?.id || ""
            })
        } else {
            setFilterInterpreters(null)
        }
    }, [item?.interpreter])

    const filteredInterpretersLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchAvailableVendorInterpreters(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: `${val.first_name || ""} ${val.last_name || ""}`.trim(),
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion
    const isUrgent = !!item?.is_urgent_effective;


    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <FormProvider {...methods}>
                    <form action="" onSubmit={handleSubmit((data) => onConfirm(data, modalType === 'accept' ? "accept" : "assign"))}>

                        <ModalHeader className='header_modal align-items-center'>
                            <h5 className="modal-title_u">{modalType == 'accept' ? 'Accept Appointment' : 'Assign Interpreter'}</h5>
                        </ModalHeader>
                        <ModalBody className='modal_form_body'>
                            <div className='step_cards step_1'>
                                <h2>{modalType == 'accept' ? 'Accept Appointment' : 'Assign'}</h2>
                                {/* INTERPRETER SELECT */}
                                <div className="row-primary">
                                    {/* Urgent appointments must be accepted with an interpreter -
                                        the backend rejects the accept otherwise. */}
                                    <h2>Interpreter {modalType === 'accept' && !isUrgent ? '' : '*'}</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="interpreter_id"
                                            rules={{
                                                required: modalType === 'accept' && !isUrgent ? false : 'Please select interpreter'
                                            }}

                                            control={control}
                                            render={({ field }) =>
                                                <div style={{ width: "100%" }}>
                                                    <AsyncPaginate
                                                        menuPlacement='auto'
                                                        styles={{
                                                            ...selectCustomStyles,
                                                        }}
                                                        value={filterInterpreters}
                                                        loadOptions={filteredInterpretersLoadOptions}
                                                        isClearable
                                                        escapeClearsValue
                                                        onChange={(obj) => {
                                                            if (obj?.value) {
                                                                setFilterInterpreters(obj)
                                                                field.onChange(obj.value);
                                                            }
                                                            else {
                                                                setFilterInterpreters(null)
                                                                field.onChange(null);
                                                            }
                                                        }}
                                                        additional={{
                                                            page: item?.state?.id ? 2 : 1,
                                                        }}
                                                    />
                                                </div>
                                            }
                                        />
                                        {errors?.interpreter_id?.message && <ErrorMessage text={errors.interpreter_id.message} />}
                                        {modalType === 'accept' && isUrgent && (
                                            <div style={{ fontSize: 12, color: '#b91c1c', marginTop: 4 }}>
                                                This appointment is urgent - an interpreter must be assigned when accepting it
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {modalType === 'accept' && (
                                    <div className="row-primary">
                                        <h2>Your IMS ID #</h2>
                                        <div className="w-100">
                                            <Controller
                                                name="ims_id"
                                                control={control}
                                                render={({ field }) =>
                                                    <div style={{ width: '100%' }}>
                                                        <input
                                                            {...field}
                                                            type="text"
                                                            className="input-in type_inp"
                                                            placeholder="Enter your IMS ID (optional)"
                                                        />
                                                    </div>
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <SubmitButton btnText="Submit" loader={loader} />
                            <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                        </ModalFooter>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default SelectInterpreterModal;